import type { ConversationNodeMessengerInput } from 'lib-shared-types-api';

type Props = {
  node: ConversationNodeMessengerInput;
};

export function RoutedThroughMessengerInput({ node }: Props): JSX.Element {
  return (
    <>
      Input · <strong>{node.input}</strong>
    </>
  );
}
